import React from 'react'
import { Button, Modal, Fade, Grid, Backdrop, Typography, Divider } from '@material-ui/core'
import { ButtonWithLoading } from 'components/ButtonWithLoading'
import useStyles from './styles'

export const Espelho = (props) => {
  const { aberto, setAberto, handleConfirmar, processando, disabled = false, titulo, children } = props
  const classes = useStyles()

  const fecharModal = () => {
    setAberto(false)
  }

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      className={classes.modal}
      open={aberto}
      onClose={fecharModal}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
      // style={{ overflowY: 'auto' }}
    >
      <Fade in={aberto} style={{ maxHeight: '90vh', overflowY: 'auto' }}>
        <Grid container className={classes.paper} >
          <Grid>
            <Typography className={classes.tituloEspelho}>
              <b>{titulo ? titulo.toUpperCase() : ''}</b>
            </Typography>
          </Grid>
          <Grid item md={12} sm={12} xs={12} className={classes.divider}>
            <Divider />
          </Grid>
          <Grid item md={12} sm={12} xs={12}>
            <Grid container className={classes.corpoEspelho}>
              {children}
            </Grid>
          </Grid>
          <Grid item md={12} sm={12} xs={12} className={classes.divider}>
            <Divider />
          </Grid>
          <Grid container justifyContent="space-between" className={classes.buttons}>
            <Grid item>
              <Button aria-controls="customized-menu" onClick={fecharModal} variant="contained" size="small" className={classes.botaoVoltar}>
                Cancelar
              </Button>
            </Grid>
            <Grid item>
              <ButtonWithLoading color="secondary" isDisabled={processando || disabled} size="small" type="submit" variant="contained" label="Confirmar" isLoading={processando} onClick={() => handleConfirmar()} />
            </Grid>
          </Grid>
        </Grid>
      </Fade>
    </Modal>
  )
}
